import {BaseDataSource} from './BaseDataSource';
import {Customer} from '../Entities/Customer';
import {TransportStats} from '../Entities/TransportStats';

/**
 * Data source to provide what data should be rendered in the table. The observable provided
 * in connect should emit exactly the data that should be rendered by the table. If the data is
 * altered, the observable should emit that new set of data on the stream. In our case here,
 * we return a stream that contains only one set of data that doesn't change.
 */
export class TransportStatsDataSource extends BaseDataSource<TransportStats> {
}



// WEBPACK FOOTER //
// /app/src/model/DataSources/TransportStatsDataSource.ts